import React, { useEffect, useState } from "react";
import Button from "@/atoms/Button";
import { MiniPlayBtnIcon } from "@/atoms/Icons";
import Modal from "@/components/molecules/Modal";
import VideoModal from "@/components/molecules/VideoModal";
import { PlayBtnIcon } from "@/atoms/Icons";
import { isMobileScreen } from "@/utils/functions";

const VideoModalTrigger = ({
  variant = "default",
  src,
  className,
  isBtnCenter,
  isSwiperBtn,
  btnSizeDesk,
  btnSizeMob,
  hasYTShorts,
}) => {
  const [showModal, setShowModal] = useState(false);

  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    setIsMobile(isMobileScreen);
  }, []);

  const videoHandler = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  return (
    <>
      {variant === "default" ? (
        <>
          <button
            className={`${className} ${
              isBtnCenter
                ? "ps-centered"
                : isSwiperBtn
                ? "swiper-btn"
                : "ppnb-btn"
            }`}
            onClick={videoHandler}
          >
            <PlayBtnIcon
              width={!isMobile ? btnSizeDesk : btnSizeMob}
              height={!isMobile ? btnSizeDesk : btnSizeMob}
            />
          </button>
          <style jsx>{`
            .ppnb-btn,
            .swiper-btn {
              position: absolute;
            }
            .ppnb-btn {
              right: 40px;
              bottom: 40px;
            }
            .swiper-btn {
              right: 32px;
              bottom: 32px;
            }
            @media (max-width: 650px) {
              .ppnb-btn {
                left: 50%;
                bottom: 84px;
                transform: translateX(-50%);
              }
              .swiper-btn {
                right: 24px;
                bottom: 24px;
              }
            }
          `}</style>
        </>
      ) : (
        variant === "btnWithIcon" && (
          <Button
            href="#"
            onClick={videoHandler}
            size="sm"
            className="mt-8"
            variant="ghost-light"
          >
            <span className="mr-1">Play Video</span>
            <MiniPlayBtnIcon width="13" height="16" className="btn-onHover" />
          </Button>
        )
      )}

      {showModal && (
        <Modal onClose={() => setShowModal(false)} show={showModal}>
          <VideoModal
            src={src}
            onClose={() => setShowModal(false)}
            hasYTShorts={hasYTShorts}
          />
        </Modal>
      )}
    </>
  );
};

export default VideoModalTrigger;
